function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class MauthError extends Error {
    constructor(json, cause){
        super(json.title, {
            cause
        });
        _define_property(this, "json", void 0);
        this.json = json;
    }
}
export const NotInNodeError = new MauthError({
    title: 'NotInNodeError',
    message: 'Thrown when code is executed in a Node.js environment but is intended for use in a browser or other non-Node environment.'
});
export const AlreadyInitializedError = new MauthError({
    title: 'AlreadyInitializedError',
    message: 'Thrown when an initialization function is called more than once, but it should only be executed once.'
});
export const NotInitializedError = new MauthError({
    title: 'NotInitializedError',
    message: 'Thrown when a required initialization has not been performed before attempting to use a function or resource.'
});
